import React, { useMemo, useState } from 'react';
import PublicShell from './PublicShell';
import { useJsonApi } from './useJsonApi';
import ReviewBody from './ReviewBody';

export default function DeploymentPublic() {
  const [mode, setMode] = useState('individual');
  const [selected, setSelected] = useState('');
  const [engineShift, setEngineShift] = useState('');

  const url = useMemo(() => {
    const employee = mode === 'individual' ? selected : '';
    return `/api/review${employee ? `?employee=${encodeURIComponent(employee)}` : ''}`;
  }, [mode, selected]);

  const api = useJsonApi(url);
  const data = api.data || {};

  return (
    <PublicShell
      title="Deployment Staffing Review"
      subtitle="7-day staffing impact"
      freshness={data.generatedAt || ''}
    >
      {api.error && <div className="pub-error">{api.error}</div>}
      <ReviewBody
        data={data}
        mode={mode}
        setMode={setMode}
        selected={selected}
        setSelected={setSelected}
        engineShift={engineShift}
        setEngineShift={setEngineShift}
        refresh={api.refresh}
        loading={api.loading}
      />
    </PublicShell>
  );
}
